import React from "react";

import {StatusBar} from "../../Components/StatusBar/StatusBar";

import "./StatusBarContainer.scss";

/**
 * Renders the status bar.
 * @return {JSX.Element}
 */
export function StatusBarContainer () {
    return (
        <StatusBar></StatusBar>
    );
}
